// Lightweight Web-Audio SFX engine — synthesized, zero asset downloads.
let ctx, master, ambient = null, engine = null;
let muted = (() => { try { return localStorage.getItem("lhl_muted") === "1"; } catch (e) { return false; } })();

function ac() {
  if (!ctx) {
    ctx = new (window.AudioContext || window.webkitAudioContext)();
    master = ctx.createGain();
    master.gain.value = muted ? 0 : 0.5;
    master.connect(ctx.destination);
  }
  if (ctx.state === "suspended") ctx.resume();
  return ctx;
}

function tone({ freq = 440, dur = 0.12, type = "sine", vol = 0.3, slideTo, delay = 0 }) {
  if (muted) return;
  const c = ac();
  const t = c.currentTime + delay;
  const o = c.createOscillator();
  const g = c.createGain();
  o.type = type;
  o.frequency.setValueAtTime(freq, t);
  if (slideTo) o.frequency.exponentialRampToValueAtTime(slideTo, t + dur);
  g.gain.setValueAtTime(vol, t);
  g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
  o.connect(g); g.connect(master);
  o.start(t); o.stop(t + dur + 0.03);
}

function noiseBuffer(c, secs) {
  const b = c.createBuffer(1, c.sampleRate * secs, c.sampleRate);
  const d = b.getChannelData(0);
  for (let i = 0; i < d.length; i++) d[i] = Math.random() * 2 - 1;
  return b;
}

export const sfx = {
  resume() { try { ac(); } catch (e) { /* no audio */ } },
  isMuted() { return muted; },
  setMuted(m) {
    muted = m;
    try { localStorage.setItem("lhl_muted", m ? "1" : "0"); } catch (e) { /* ignore */ }
    if (master) master.gain.value = m ? 0 : 0.5;
    if (m) { this.engineStop(); this.ambientOff(); }
  },
  tap() { tone({ freq: 620, dur: 0.05, type: "triangle", vol: 0.14 }); },
  coin() { tone({ freq: 880, dur: 0.08, type: "square", vol: 0.18 }); tone({ freq: 1320, dur: 0.1, type: "square", vol: 0.16, delay: 0.07 }); },
  win() { [523, 659, 784, 1047].forEach((f, i) => tone({ freq: f, dur: 0.15, type: "triangle", vol: 0.2, delay: i * 0.08 })); },
  error() { tone({ freq: 220, dur: 0.28, type: "sawtooth", vol: 0.18, slideTo: 90 }); },
  whoosh() {
    if (muted) return;
    const c = ac(); const t = c.currentTime;
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 0.45);
    const f = c.createBiquadFilter(); f.type = "bandpass";
    f.frequency.setValueAtTime(350, t); f.frequency.exponentialRampToValueAtTime(2200, t + 0.4);
    const g = c.createGain(); g.gain.setValueAtTime(0.22, t); g.gain.exponentialRampToValueAtTime(0.001, t + 0.44);
    s.connect(f); f.connect(g); g.connect(master); s.start(t); s.stop(t + 0.46);
  },
  horn() { tone({ freq: 330, dur: 0.32, type: "square", vol: 0.22 }); tone({ freq: 247, dur: 0.32, type: "square", vol: 0.18 }); },
  rev() { tone({ freq: 90, dur: 0.35, type: "sawtooth", vol: 0.2, slideTo: 220 }); },
  engineStart() {
    if (muted || engine) return;
    const c = ac();
    const o = c.createOscillator(); o.type = "sawtooth"; o.frequency.value = 68;
    const lfo = c.createOscillator(); lfo.type = "sine"; lfo.frequency.value = 11;
    const lg = c.createGain(); lg.gain.value = 16; lfo.connect(lg); lg.connect(o.frequency);
    const f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 300;
    const g = c.createGain(); g.gain.value = 0.11;
    o.connect(f); f.connect(g); g.connect(master);
    o.start(); lfo.start(); engine = { o, lfo };
  },
  engineStop() { if (engine) { try { engine.o.stop(); engine.lfo.stop(); } catch (e) { /* ignore */ } engine = null; } },
  ambientOn() {
    if (muted || ambient) return;
    const c = ac();
    const s = c.createBufferSource(); s.buffer = noiseBuffer(c, 2); s.loop = true;
    const f = c.createBiquadFilter(); f.type = "lowpass"; f.frequency.value = 650;
    const g = c.createGain(); g.gain.value = 0.045;
    s.connect(f); f.connect(g); g.connect(master); s.start(); ambient = { s };
  },
  ambientOff() { if (ambient) { try { ambient.s.stop(); } catch (e) { /* ignore */ } ambient = null; } },
};
